module.exports = __webpack_public_path__ + "static/media/FVCON-marca-registrada-azul-negro.d8867f97.png";